import type { AssessmentElement, AssessmentFormValues } from "../types";

/**
 * Generate default form values from assessment elements.
 * Ensures checkbox fields start as empty arrays instead of undefined,
 * preventing validation errors on submit.
 *
 * @param elements - Assessment elements from the API
 * @returns Default values object for React Hook Form, properly typed
 */
export const createDefaultFormValues = (elements: AssessmentElement[]): AssessmentFormValues => {
  if (!elements || elements.length === 0) {
    return {};
  }

  const defaults: Record<string, string | string[]> = {};

  elements.forEach((element) => {
    switch (element.type) {
      case "checkbox":
        defaults[element.name] = []; // Empty array for checkboxes
        break;

      case "radiogroup":
      case "rating":
        defaults[element.name] = ""; // Empty string for radio/rating
        break;
    }
  });

  return defaults;
};
